/**
 * 理疗划价模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 新增理疗处方划价单 --- 馆内、电子处方
export const physioPaymentAdd1 = (params) => {
  return req.post('/order/payment/physio', params);
}

// 新增理疗处方划价单 手写、补录 --- 馆内、手写处方
export const physioPaymentAdd2 = (params) => {
  return req.post('/order/payment/physio/handwrittenAdd', params);
}

// 新增理疗处方划价单 自建收费 --- 馆内/馆外、手写处方
export const physioPaymentAdd3 = (params, uuid, code) => {
  return req.post(`/order/payment/physio/selfBuiltAdd?uuid=${uuid}&code=${code}`, params);
}

// 修改理疗处方划价单
export const physioPaymentEdit = (params) => {
  return req.put('/order/payment/physio', params);
}

// 理疗处方划价单付款
export const physioPaymentPay = (params) => {
  return req.post(`/order/payment/physio/payment`, params);
}

// 根据理疗处方id获取理疗处方划价单详情
export const physioPaymentInfo = (recipePhysioId, orderId) => {
  return req.get(`/order/payment/physio/recipe/${recipePhysioId}/${orderId}`);
}

// 根据理疗处方划价单id删除理疗划价单
// export const physioPaymentDelete = (orderPaymentRecipePhysioIds) => {
//   return req.delete(`/order/payment/physio/${orderPaymentRecipePhysioIds}`);
// }
export const physioPaymentDelete = (params) => {
  return req.delete(`/order/payment/physio`,params);
}

// 根据理疗处方划价单id作废理疗处方划价单
export const physioPaymentInvalid = (params) => {
  return req.post(`/order/payment/physio/invalid`,params);
}

// 根据理疗处方划价单信息退款
export const physioPaymentRefund = (params) => {
  return req.post(`/order/payment/physio/refund`, params);
}

// 根据理疗处方划价单id退款 --- 微信支付
export const physioPaymentRefund1 = (orderPaymentRecipePhysioId) => {
  return req.post(`/wechat/pay/physioRefund/${orderPaymentRecipePhysioId}`);
}

// 查询理疗处方划价单列表
export const physioPaymentList = (params) => {
  return req.get(`/order/payment/physio/list`, params);
}

// 根据理疗处方划价单id获取理疗处方划价单详情
export const physioPaymentDetails = (paymentRecipePhysioId) => {
  return req.get(`/order/payment/physio/${paymentRecipePhysioId}`);
}

// 根据理疗处方划价单id获取小票信息
export const physioSmallTicket = (orderPaymentRecipePhysioId) => {
  return req.get(`/order/payment/physio/printCharge/${orderPaymentRecipePhysioId}`);
}

// 根据理疗处方划价单id获取处方打印详情
export const physio = (orderPaymentRecipePhysioId, type) => {
  return req.get(`/order/payment/physio/printPhysioRecipe/${orderPaymentRecipePhysioId}/${type}`);
}

// 多条理疗处方划价单付款
export const paymentAllPhysio = (list) => {
  return req.post(`/order/payment/physio/payments`, list);
}

// 查询理疗处方划价单状态数量
export const statusNumPhysio = (params) => {
  return req.get(`/order/payment/physio/selectStatusNumber`, params);
}